/**
* ***************************
* Domain Routes Components in Email Gateway *
* ***************************
*/
const Domains = () => import('@/components/Organisations/Domains/Domains');
const EditDomain = () =>
 import('@/components/Organisations/Domains/Domain/EditDomain');
const Domaindetail = () =>
 import('@/components/Organisations/Domains/DomainLandingPage');

export default {
    title: 'Domains',
    link: '/email-gateway/domains',
    permission: [
        {
            action: 'manage',
            entity: 'organisation'
        },
        { action: 'view', entity: 'email_gateway' }
    ],
    path: 'domains',
    component: Domains,
    meta: {
        permission: [
            {
                action: 'manage',
                entity: 'organisation'
            },
            { action: 'view', entity: 'email_gateway' }
        ]
    },
    children: [
        {
            path: '/email-gateway/domains',
            redirect: '/email-gateway/domains/details'
        },
        {
            path: 'details',
            component: Domaindetail,
            permission: [
                [
                    {
                        action: 'manage',
                        entity: 'organisation'
                    },
                    { action: 'view', entity: 'email_gateway' }
                ]
            ],
            meta: {
                permission: [
                    {
                        action: 'manage',
                        entity: 'organisation'
                    },
                    { action: 'view', entity: 'email_gateway' }
                ]
            }
        },
        {
            path: 'edit-domain/:domainId',
            component: EditDomain,
            permission: [
                [
                    {
                        action: 'manage',
                        entity: 'organisation'
                    },
                    { action: 'view', entity: 'email_gateway' }
                ]
            ],
            meta: {
                permission: [
                    {
                        action: 'manage',
                        entity: 'organisation'
                    },
                    { action: 'view', entity: 'email_gateway' }
                ]
            }
        }
    ]
};